import useAuthStore from "../stores/useAuthStore";
import useReferenceStore from "../stores/useReferenceStore";
import useTransactionStore from "../stores/useTransactionStore";

/**
 * Determine if a transaction is inter-state based on customer address vs store location.
 * Extracted from useOrderProcessing.getIsInterState for reuse in printers and tax breakup.
 *
 * @param {Object} cart - Cart/order object with customer.metaData
 * @returns {boolean}
 */
export function getIsInterState(cart) {
  try {
    const tillData = useAuthStore.getState().tillData;
    const storeStateId = tillData?.tillAccess?.csBunit?.csRegionId || "";
    if (!storeStateId) return false;

    // Read B2B flag from both sources — createCustomer sets only the store,
    // editOldCustomer sets both. Checking both ensures correct group name in all flows.
    const storedB2B =
      localStorage.getItem("isB2bEnabled") === "true" ||
      useTransactionStore.getState().isB2bEnabled === "true";
    const groupName = storedB2B ? "Delivery Address" : "Address";

    let customerStateId = "";

    // Primary: resolve state from the customer config address group in metaData
    const customerConfigs = useReferenceStore.getState().customerConfigs;
    const customerConfigData = customerConfigs?.[0]?.configuration
      ? JSON.parse(customerConfigs[0].configuration)
      : {};
    const fieldGroups = customerConfigData?.fieldGroups || [];
    const groupId = fieldGroups.find((g) => g.name === groupName)?.id;

    if (groupId) {
      const metaRow = cart?.customer?.metaData?.find((item) => item.key === groupId);
      console.log("[BUG-1511] groupName:", groupName, "groupId:", groupId, "metaRow:", metaRow ? JSON.stringify(metaRow) : "NOT FOUND");
      if (metaRow?.value) {
        const parsed =
          typeof metaRow.value === "string" ? JSON.parse(metaRow.value) : metaRow.value;
        console.log("[BUG-1511] parsed address group:", JSON.stringify(parsed));
        customerStateId = parsed?.state || "";

        // Resolve name → RecordID if needed
        if (customerStateId) {
          const statesData = useReferenceStore.getState().statesData;
          const isId = statesData.some((s) => s.RecordID === customerStateId);
          if (!isId) {
            const match = statesData.find(
              (s) => s.Name?.toLowerCase() === customerStateId.toLowerCase()
            );
            customerStateId = match?.RecordID || "";
          }
        }
      }
    } else {
      console.log("[BUG-1511] groupId NOT found for groupName:", groupName, "— available fieldGroups:", JSON.stringify(fieldGroups.map((g) => ({ id: g.id, name: g.name }))));
    }
    console.log("[BUG-1511] all metaData keys:", JSON.stringify((cart?.customer?.metaData || []).map((m) => m.key)));

    // Fallback for B2C: if the metaData group did not yield a state, use the
    // customerAddress.csRegionId that is explicitly saved on the customer record.
    // This covers customers without a group-based address in metaData and also
    // guards against the backend not echoing the metaData group back.
    if (!customerStateId && !storedB2B) {
      const fallbackId = cart?.customer?.customerAddress?.csRegionId || "";
      if (fallbackId) {
        console.log("[TAX-DEBUG] getIsInterState: metaData group had no state — using customerAddress.csRegionId fallback:", fallbackId);
      }
      customerStateId = fallbackId;
    }

    console.log("[TAX-DEBUG] getIsInterState:", { storeStateId, customerStateId, storedB2B, isInterState: Boolean(customerStateId && storeStateId !== customerStateId) });
    return Boolean(customerStateId && storeStateId !== customerStateId);
  } catch {
    return false;
  }
}
